import apiRequestType from "../../apiRequestType";
import { apiConstants } from "../../../utils/apiConstants";
import { apiTypes } from "../../../utils/apiTypes";

const getForumComments = (threadId, pageNum, pageSize) => {
  return apiRequestType(
    apiTypes.GET,
    apiConstants.SOCIAL.FORUM_AREA.FORUM_COMMENTS(threadId, pageNum, pageSize)
  );
};

export default getForumComments;
